import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CoverCropsDocument,
  CoverCropsQuery,
  CoverCropsQueryVariables,
  CreateCoverCropDocument,
  CreateCoverCropInput,
  CreateCoverCropMutation,
  CreateCoverCropMutationVariables,
} from "generated/graphql";

@injectable()
export class CoverCropService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      CoverCropsQuery,
      CoverCropsQueryVariables
    >({
      query: CoverCropsDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.coverCrops;
  }

  async create(input: CreateCoverCropInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateCoverCropMutation,
      CreateCoverCropMutationVariables
    >({
      mutation: CreateCoverCropDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: CoverCropsDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createCoverCrop;
  }
}
